module.exports = __webpack_public_path__ + "r-v3/img/ico_more_gray.ec815272.svg";